export default "__VITE_ASSET__DjXjce_O__"